import * as React from "react";
import type { SVGProps } from "react";
const SvgAirplaneToTop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.86 22h-5.7c-1.46 0-2.65-1.19-2.65-2.65 0-1.26.9-2.35 2.13-2.6l.37-.07v-1.69l-4.35-.02c-.7.01-1.36-.26-1.87-.76S2 13.05 2 12.34c0-1.26.89-2.34 2.13-2.58L9 8.81V5c0-1.65 1.35-3 3-3s3 1.35 3 3v3.81l4.86.95C21.1 10 22 11.09 22 12.36c0 1.46-1.19 2.65-2.65 2.65H15v1.68l.37.07c1.23.25 2.13 1.34 2.13 2.6 0 1.46-1.19 2.65-2.65 2.65l.01-.01ZM4.65 12.98l5.36.02c.55 0 1 .45 1 1v3.5c0 .48-.34.89-.8.98l-1.17.23c-.3.06-.52.33-.52.64 0 .36.29.65.65.65h5.7c.36 0 .65-.29.65-.65 0-.31-.22-.58-.52-.64l-1.17-.23c-.47-.09-.8-.5-.8-.98V14c0-.55.45-1 1-1h5.35c.36 0 .65-.29.65-.65 0-.31-.22-.57-.52-.63l-5.67-1.11a.997.997 0 0 1-.81-.98V5c0-.55-.45-1-1-1s-1 .45-1 1v4.63c0 .48-.34.89-.81.98l-5.68 1.11c-.29.06-.51.32-.51.62 0 .17.07.33.19.45s.28.18.44.18l-.01.01Z"
    />
  </svg>
);
export default SvgAirplaneToTop;
